import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import Delete from '@mui/icons-material/Delete'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@carsys/ui'

import { IssueList } from './IssueList'
import { DeleteIssue } from './to-issues'

interface RejectionDialogProps {
  deletedItemString: string
  scope: string
  onCancel: () => void
  rejections: DeleteIssue[]
  warnings: DeleteIssue[]
}

export function RejectionDialog(props: RejectionDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog fullWidth open>
      <DialogTitle>{t('DeleteFlow.RejectionDialog.Title', { item: props.deletedItemString })}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('DeleteFlow.RejectionDialog.Description', { item: props.deletedItemString })}</DialogContentText>
        <IssueList
          deletedItemString={props.deletedItemString}
          scope={props.scope}
          rejections={props.rejections}
          warnings={props.warnings}
        />
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={props.onCancel}>
          {t('DeleteFlow.RejectionDialog.Cancel')}
        </Button>
        <Button color='primary' disabled startIcon={<Delete />} variant='contained'>
          {t('DeleteFlow.RejectionDialog.Confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
